import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Box, Button,
} from '@material-ui/core';
import {
  Refresh, Autorenew,
} from '@material-ui/icons';
import {
  MATCHING_COMPANY_TAB,
  INPUT,
  UPDATE_BUTTON_DISP_STATUS,
  DOWNLOAD_BUTTON_DISP_STATUS,
  DELIMITER_MATCHING,
  CHAR_CODE_MATCHING,
} from '../../../common/const';
import MatchingSettingComponent from './MatchingSettingComponent';
import MatchingResultComponent from './MatchingResultComponent';
import {
  setDispTab,
  fileUploadExecute,
  setErrMatchingFile,
  setErrUploadMemoFlg,
  setErrUploadMemoMsg,
  setUploadMemo,
  setCharCode,
  setDelimiter,
  fileCreateExecute,
  fileDownloadExecute,
  searchMatchingJobList,
  filterJobList,
} from '../../actions/MatchingAction';
import {
  setErrorMessage,
  setInitMessage,
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import config from '../../../common/config';
import styles from './MatchingAreaComponent.module.css';
import MyIcon from '../common/MyIcon';

class MatchingAreaComponent extends Component {
  /**
 * タブ切り替え
 */
  tabClick = (newTab) => {
    const { setDispTabAct } = this.props;
    setDispTabAct(newTab);
  }

  /**
   * マッチング実行
   */
  onClickMatchingButton = async () => {
    const {
      setInitMessageAct,
      setErrorMessageAct,
      fileUploadExecuteAct,
      setErrMatchingFileAct,
      setErrUploadMemoFlgAct,
      setErrUploadMemoMsgAct,
      uploadMemo,
      charCode,
      delimiter,
    } = this.props;

    // ファイル取得
    const file = document.getElementById('matchingFile').files[0];

    // メッセージエリア初期化
    setInitMessageAct();
    const msgs = [];

    // アップロードメモの文字数チェック
    validator.checkMaxLength(uploadMemo, 50, msgs);
    // 文字数エラーがあった場合、エラーメッセージ表示
    if (msgs.length !== 0) {
      setErrUploadMemoFlgAct(true);
      setErrUploadMemoMsgAct(getMessage(ERROR.E08009, msgs.join(',')));
      return;
    }

    // ファイル形式チェック
    this.validatorFile(
      INPUT.MATCHING.MATCHING_FILE, file, msgs, null, delimiter,
    );

    if (msgs.length > 0) {
      setErrorMessageAct(msgs);
      setErrMatchingFileAct(true);
      return;
    }

    // ファイルアップロードAPI実行
    setErrMatchingFileAct(false);
    await fileUploadExecuteAct(
      file,
      uploadMemo,
      charCode,
      delimiter,
    );
  }

  // ファイル形式チェック
  validatorFile = (name, file, msgs, key = name, delimiter) => {
    const i = msgs.length;
    const pattern = (delimiter === DELIMITER_MATCHING.COMMA
      ? VALIDATOR_CONST.PATERN_CSV : VALIDATOR_CONST.PATERN_TSV);
    validator.checkFileStatus(
      name,
      file,
      config.FILE_SIZE_LIMIT.MATCHING_COMPANY,
      pattern,
      config.FILE_NAME_LIMIT.MATCHING_COMPANY,
      msgs,
      key,
    );
    return i !== msgs.length;
  }

  /**
 * クリアボタン押下
 */
  clear = () => {
    const {
      setInitMessageAct,
      setErrMatchingFileAct,
      setErrUploadMemoFlgAct,
      setErrUploadMemoMsgAct,
      setUploadMemoAct,
      setCharCodeAct,
      setDelimiterAct,
    } = this.props;

    // ファイル選択クリア
    document.getElementById('matchingFile').value = null;
    const file = document.getElementById('matchingFile').files[0];
    if (file === undefined) {
      document.getElementById('filemessage').innerText = '選択されていません';
    }
    setInitMessageAct();
    setErrMatchingFileAct(false);
    setErrUploadMemoFlgAct(false);
    setUploadMemoAct(null);
    setCharCodeAct(CHAR_CODE_MATCHING.SJIS);
    setDelimiterAct(DELIMITER_MATCHING.COMMA);
    setErrUploadMemoMsgAct('');
  }

  /**
 * ダウンロードボタン押下
 */
  onClickDownload = async (fileName) => {
    const {
      selectJob,
      fileCreateExecuteAct,
      fileDownloadExecuteAct,
      setSystemLodingFLgAct,
    } = this.props;
    setSystemLodingFLgAct(true);
    // ファイル作成API
    const delimiter = selectJob.delimiter === ',' ? DELIMITER_MATCHING.COMMA : DELIMITER_MATCHING.TAB;
    if (await fileCreateExecuteAct(selectJob.seq_id, selectJob.charset, delimiter)) {
      // ファイルダウンロードAPI
      await fileDownloadExecuteAct(selectJob.seq_id, fileName);
    }
    setSystemLodingFLgAct(false);
  }

  /**
 * 更新ボタン押下
 */
  onClickUpdateButton = async () => {
    const {
      selectJob,
      setSystemLodingFLgAct,
      searchMatchingJobListAct,
      filterJobListAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    // ジョブ一覧を選択ジョブの処理実行日を再取得
    if (await searchMatchingJobListAct(selectJob.execute_date)) {
      // ジョブ一覧から対象ジョブを抽出API
      await filterJobListAct();
    }
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      selectSequenceId,
      dispTab,
      selectJob,
    } = this.props;

    let matchingButton;
    if (dispTab === MATCHING_COMPANY_TAB.SETTING) {
      matchingButton = (
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.clear()}
            startIcon={<Refresh />}
            className={`${styles.btnSize}`}
          >
            クリア
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => this.onClickMatchingButton()}
            startIcon={<MyIcon className={`${styles.uploadIcon}`} type="upload" />}
            className={`${styles.btnSize} ${styles.marginLeftHalf}`}
          >
            マッチング実行
          </Button>
        </Box>
      );
    }

    let downloadButton;
    let updateButton;
    if (dispTab === MATCHING_COMPANY_TAB.RESULT) {
      if (DOWNLOAD_BUTTON_DISP_STATUS.includes(selectJob.status)) {
        const downloadFileName = (selectJob.delimiter === DELIMITER_MATCHING.TAB
          ? selectJob.file_name.replace('.tsv', '').concat('_result.tsv') : selectJob.file_name.replace('.csv', '').concat('_result.csv'));
        downloadButton = (
          <Box>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => this.onClickDownload(downloadFileName)}
              startIcon={<MyIcon className={`${styles.downloadIcon}`} type="download" />}
              className={`${styles.btnSize}`}
            >
              ダウンロード
            </Button>
          </Box>
        );
      }
      if (UPDATE_BUTTON_DISP_STATUS.includes(selectJob.status)) {
        updateButton = (
          <Box className="buttondiv">
            <Button
              variant="contained"
              className={`${styles.btnSize} addAll`}
              onClick={() => this.onClickUpdateButton()}
              startIcon={<Autorenew />}
            >
              更新
            </Button>
          </Box>
        );
      }
    }

    return (
      <Box>
        <Box display="flex" justifyContent="space-between">
          <div className="tabGroup">
            <Button
              className={[
                `${styles.tabSize} tab`,
                dispTab === MATCHING_COMPANY_TAB.SETTING ? 'selected' : null,
              ].join(' ')}
              onClick={() => {
                this.tabClick(MATCHING_COMPANY_TAB.SETTING);
              }}
              tabIndex="-1"

            >
              マッチング設定
            </Button>
            <Button
              className={[
                `${styles.tabSize} tab`,
                dispTab === MATCHING_COMPANY_TAB.RESULT ? 'selected' : null,
                selectSequenceId ? null : 'disabled',
              ].join(' ')}
              onClick={() => {
                this.tabClick(MATCHING_COMPANY_TAB.RESULT);
              }}
              disabled={!selectSequenceId}
              tabIndex="-1"
            >
              マッチング結果
            </Button>
          </div>
          {matchingButton}
          {downloadButton}
          {updateButton}
        </Box>
        {dispTab === MATCHING_COMPANY_TAB.SETTING
          ? <MatchingSettingComponent />
          : <MatchingResultComponent />}
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    dispTab: state.matching.dispTab,
    selectSequenceId: state.matching.selectSequenceId,
    selectJob: state.matching.selectJob,
    errUploadMemoFlg: state.matching.errUploadMemoFlg,
    errUploadMemoMsg: state.matching.errUploadMemoMsg,
    errMatchingFile: state.matching.errMatchingFile,
    uploadMemo: state.matching.uploadMemo,
    charCode: state.matching.charCode,
    delimiter: state.matching.delimiter,
  }),
  (dispatch) => ({
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setErrorMessageAct: (errorMessage) => dispatch(setErrorMessage(errorMessage)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    setDispTabAct: (str) => dispatch(setDispTab(str)),
    setUploadMemoAct: (str) => dispatch(setUploadMemo(str)),
    setCharCodeAct: (str) => dispatch(setCharCode(str)),
    setDelimiterAct: (str) => dispatch(setDelimiter(str)),
    setErrMatchingFileAct: (bool) => dispatch(setErrMatchingFile(bool)),
    setErrUploadMemoFlgAct: (bool) => dispatch(setErrUploadMemoFlg(bool)),
    setErrUploadMemoMsgAct: (str) => dispatch(setErrUploadMemoMsg(str)),
    searchMatchingJobListAct: (excutionDate) => dispatch(searchMatchingJobList(excutionDate)),
    filterJobListAct: () => dispatch(filterJobList()),
    fileUploadExecuteAct: (
      uploadFile,
      uploadMemo,
      charCode,
      delimiter,
    ) => dispatch(fileUploadExecute(
      uploadFile,
      uploadMemo,
      charCode,
      delimiter,
    )),
    fileCreateExecuteAct: (seqId, charCode, delimiter) => dispatch(fileCreateExecute(
      seqId, charCode, delimiter,
    )),
    fileDownloadExecuteAct: (seqId, fileName) => dispatch(fileDownloadExecute(
      seqId, fileName,
    )),
  }),
)(MatchingAreaComponent);
